import React, { useEffect, useState } from 'react';
import { getLeadsAPI } from '../services/Leadservice';
import Button from 'react-bootstrap/Button'
import { Container } from "react-bootstrap";
import '../style/componentstyles.css'
import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import { getUserCompany } from "../services/UserService";
import { useAuth } from "../contexts/AuthContext";
import { Dropdown } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import LoadingLoginScreen from "./LoadingLoginScreen";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import moment from "moment";
import { ShowFinishedDealDetails } from './ShowFinishedDealDetails';


export default function LeadsGrid(props) {

    let location = useLocation();

    const { SearchBar } = Search;


    const { currentUser } = useAuth();
    const [leads, setLeads] = useState([]);
    const [filteredLeads, setFilteredLeads] = useState([])
    const [completedLeads, setCompletedLeads] = useState([])
    const [focusButton, setFocusButton] = useState(0)
    const [company, setCompany] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [disabledText, setDisabledText] = useState(false);
    const [successText, setSuccessText] = useState("");


    let timer;
    useEffect(() => {


        if (location.pathname === "/dashboard" || location.pathname === "/") {
            setDisabledText(true)
        }
        setLoading(true)
        const getUser = async () => {
            if (currentUser) {
                const res = await getUserCompany(currentUser.uid)
                setCompany(res)

            }
        }
        getUser()

        const getLeads = async () => {
            const arr = await getLeadsAPI(company, props.value)

            const noDeclinedLeads = arr.filter(l => l.dealstage !== "17878478" && l.dealstage !== "17878477")
            const leadsCompleted = arr.filter(l => l.dealstage === "17878477")
            setLeads(noDeclinedLeads);
            setFilteredLeads(noDeclinedLeads)
            setCompletedLeads(leadsCompleted)


        }

        getLeads().then(() => {
            setSuccess(true)
            setSuccessText("Lyckad inladdning av Leads")
        })
            .catch(() => {
                setSuccess(true)
                setSuccessText("Misslyckad inladdning av Leads")
            })

        timer = setTimeout(() => {
            setSuccess(false)
        }, 5000)

        setLoading(false)

        clearTimeout(timer);
    }, [company])

    const displayStatus = (cell) => {
        switch (cell) {

            case true:
                return <Button variant="success" disabled>Lead Godkänd</Button>
            case false:
                return <Button variant="danger">Nekad Lead</Button>
            default:
                return <Button variant="warning" disabled>Ej Behandlad</Button>
        }
    }

    const displayDealstage = (cell) => {
        switch (cell) {
            case 'appointmentscheduled':
                return "Inkommen Lead"

            case 'qualifiedtobuy':
                return "Offert Skickad"

            case '17878477':
                return 'Offert Godkänd'

            case '17878478':
                return 'Offert Nekad'

            case '41454020':
                return 'Offert sedd'

            case '47368172':
                return "Offert Skapad"

        }
    }
    const dateFormatter = (cell) => {
        if (cell) {
            return moment(cell.toDate()).format("YYYY-MM-DD")
        } else return <span>Inget datum</span>
    }


    const createQuoteButton = (cell, lead) => {

        if (lead.status === "document.signed") {
            return (
                <ShowFinishedDealDetails docID={cell} />
            )
        } else {

            return (
                <Link to={`/lead/${cell}`}>
                    <Button variant={"success"}>Detaljer</Button>
                </Link>
            )
        }
    }


    const columns = [{
        dataField: 'firstname',
        text: 'Förnamn',
        sort: true,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }

    }, {
        dataField: 'lastname',
        text: 'Efternamn',
        sort: true,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }

    }, {
        dataField: 'reference'.toLowerCase(),
        text: 'Referens:  '.toLowerCase(),
        sort: true,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
    }, {
        dataField: 'customerPhone',
        text: 'Telefon',
        sort: true,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }

    }, {
        dataField: 'formInsertedAt',
        text: 'Inkommen',
        sort: true,
        formatter: dateFormatter,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
    }, {
        dataField: 'approved',
        text: 'Leadstatus',
        formatter: displayStatus,
        sort: true,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }

    }, {
        dataField: 'dealstage',
        text: 'Offertstatus',
        formatter: displayDealstage,
        sort: true,
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' }

    }, {
        dataField: 'id',
        text: 'Skapa',
        headerStyle: { textDecoration: 'underline', cursor: 'pointer' },
        formatter: createQuoteButton,
    },

    ];

    function filterNull() {
        let filterArr = leads.filter((lead) => lead.approved === undefined)
        setFilteredLeads(filterArr)
        setFocusButton(1)
    }

    function filterApproved() {
        let filterArr = leads.filter((lead) => lead.approved === true)
        setFilteredLeads(filterArr)
        setFocusButton(2)
    }

    function filterDeclined() {
        let filterArr = leads.filter((lead) => lead.approved === false)
        setFilteredLeads(filterArr)
        setFocusButton(3)
    }

    function filterReset() {
        setFilteredLeads(leads)
        setFocusButton(0)
    }


    return (
        <React.Fragment>
            {loading ? (


                <LoadingLoginScreen />
            ) : (
                <Container fluid className={"leadsGrid"}>


                    <span style={{ fontWeight: 'bold' }}>
                        {company}
                    </span>


                    <div style={{ paddingTop: 10, paddingBottom: 10, flexDirection: 'row' }}>
                        {disabledText ?
                            undefined :
                            <span style={{ fontWeight: 'bold' }}>
                                Antal Leads: {leads.length}  </span>
                        }


                        <Dropdown>
                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                Filtrera
                            </Dropdown.Toggle>


                            <Dropdown.Menu>
                                <Dropdown.Item>

                                    <Button style={{ color: 'black' }} onClick={filterNull}
                                        variant={focusButton === 1 ? "primary" : "outline-primary "}>Ej
                                        behandlade
                                        Leads</Button>{' '}

                                </Dropdown.Item>
                                <Dropdown.Item>

                                    <Button style={{ color: 'black' }} onClick={filterApproved}
                                        variant={focusButton === 2 ? "primary" : "outline-primary"}>Godkända
                                        Leads</Button>{' '}

                                </Dropdown.Item>

                                <Dropdown.Item>

                                    <Button style={{ color: 'white' }} onClick={filterReset}
                                        variant="dark">Återställ</Button>{' '}


                                </Dropdown.Item>

                            </Dropdown.Menu>
                        </Dropdown>


                    </div>

                    <ToolkitProvider

                        keyField="id"
                        data={filteredLeads}
                        columns={columns}
                        search
                    >
                        {props => (
                            <div>
                                <SearchBar placeholder="Sök" srText={null}
                                    className="SearchBar" {...props.searchProps} />
                                <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                            </div>
                        )}
                    </ToolkitProvider>


                    {disabledText ? undefined :
                        <ToolkitProvider

                            keyField="id"
                            data={completedLeads}
                            columns={columns}
                            search
                        >
                            {props => (
                                <React.Fragment>
                                    <label>
                                        Godkända offerter
                                    </label>
                                    <div>


                                        <SearchBar placeholder="Sök" srText={null}
                                            className="SearchBar" {...props.searchProps} />
                                        <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                                    </div>
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    }

                </Container>
            )}
        </React.Fragment>
    )
}

